import 'assets/css/NavigationStyle.css';
import 'animate.css';
import proIcon from 'assets/img/bottomNav/profile_inactive.svg';
import scanIcon from 'assets/img/bottomNav/scan_inactive.svg';
import homeIcon from 'assets/img/bottomNav/home_inactive.svg';
import activeProIcon from 'assets/img/bottomNav/profile_active.svg';
import activeScanIcon from 'assets/img/bottomNav/scan_active.svg';
import activeHomeIcon from 'assets/img/bottomNav/home_active.svg';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {BottomNavigation, BottomNavigationAction, Grid, Paper} from "@mui/material";
import ScanButton from "components/Navbar/scanButton";
import {HidingNavigation} from "helpers/BottomNavigation";
import {detectPathUrl} from "helpers/detectPathUrl";
import {useNavigationContext} from "../context/NavigationContext";


const tabs = [
    {
        index: 0,
        route: detectPathUrl('app/profile'),
        label: 'پروفایل',
        imgSrc: proIcon,
        activeImgSrc: activeProIcon,
    },
    {
        index: 1,
        route: detectPathUrl('app/scan'),
        label: 'اسکن',
        imgSrc: scanIcon,
        activeImgSrc: activeScanIcon,
    },
    {
        index: 2,
        route: detectPathUrl('app/home'),
        label: 'داشبورد',
        imgSrc: homeIcon,
        activeImgSrc: activeHomeIcon,
    },
];
export default function SimpleBottomNavigation() {
    const {nfcNotSupported} = useNavigationContext();
    const hideNav = HidingNavigation();
    const {pathname} = useLocation();
    const navigate = useNavigate();
    const navigationClick = (event, item, isSuccess = false) => {
        event.preventDefault();
        if (isSuccess) {
            const path = detectPathUrl('app/home');
            navigate({pathname: path});
        } else
            navigate(item.route);
    };
    const LabelComponent = ({isActive, label, isScan}) => {
        return (
            <span style={{position: isScan ? 'fixed': 'relative',
                            bottom: isScan ? '7px': '1px',
                            color:isActive&& !nfcNotSupported?'#753CBE':'#707070'}}
                  className='MuiBottomNavigationAction-label'>
                {label}
            </span>
        );

    };

    const onBoardClassName = (item) => item.index === 2 && 'home' || item.index === 0 && 'profile';

    return (
        <> {hideNav === 'show' &&
            <Paper className='navigation-Container' elevation={3}>
                <BottomNavigation className='bottom-nav'>
                    <Grid container>
                        {tabs.map((item, index) => {
                            let isActive = pathname === item.route;
                            return (
                                item.index === 1 ?
                                    <Grid display='flex'
                                          justifyContent='center'
                                          alignItems='center'
                                          xs={2}
                                          key={index}
                                    >
                                        <ScanButton
                                            isActive={isActive}
                                            item={item}
                                            navigationClick=
                                                {(event, item, isSuccess) => navigationClick(event, item, isSuccess)}
                                        />
                                        <LabelComponent isScan isActive={isActive} label={item.label}/>
                                    </Grid>
                                    :
                                    <BottomNavigationAction
                                        key={index}
                                        component={Link}
                                        to={item.route}
                                        showLabel
                                        label={<LabelComponent isActive={isActive} label={item.label}/>}
                                        icon={
                                            <div style={{height: '22px'}} className={onBoardClassName(item)}>
                                                <img style={{minWidth: '32px',minHeight:'32px'}}
                                                     src={isActive ? item.activeImgSrc : item.imgSrc} alt=''/>
                                            </div>}
                                        onClick={(event) => navigationClick(event, item)}
                                    />
                            );
                        })}
                    </Grid>
                </BottomNavigation>
            </Paper>

        }</>
    );
}
